var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#727A82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.406.404.007.405 1.194.398 1.193.397v6.392l-1.193.397-1.194.398-.007.405-.007.404H7.2V15.213l.393.393.393.394.407-.406.407-.407V9.6h4.8v-.796l-1.193-.397-1.194-.398V1.591l1.194-.398L13.6.796V0H2.399l.007.404",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerPin);
export default __webpack_public_path__ + "static/media/drawerPin.07b23ff07fcc4753f0cb24878a9cd900.svg";
export { ForwardRef as ReactComponent };